angular.module('impactx.swimLane', []);